// extracted by mini-css-extract-plugin
export var container = "_6n-0";
export var error = "_6n-9";
export var label = "_6n-5";
export var light = "_6n-6";
export var md = "_6n-3";
export var sm = "_6n-2";
export var thin = "_6n-8";
export var thinBold = "_6n-7";
export var vertical = "_6n-4";
export var xs = "_6n-1";